import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import MyPagination from "Components/MyPagination";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import DatePickers from "Components/DatePickers";
import Layout from "Layout";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LaunchIcon from "@material-ui/icons/Launch";
import PosiTabs from "Components/PosiTabs";
import { withRouter } from "react-router";
import { fromMonthly, toMonthly } from "fuction/date";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import useFilter from "Hooks/useFilter";
import replaceTweetText from "fuction/replaceTweetText";
import { animateScroll as scroll } from 'react-scroll';
import googleAnalytics from "fuction/googleAnalytics";
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Toolbar from '@material-ui/core/Toolbar';
import { useQueryString, modQueryPageNum, getQueryPageNum } from "Hooks/useQueryString";

const useStyles = makeStyles((theme) => ({
  rank: {
    textAlign: "center",
    width: "120px",
  },
  count: {
    textAlign: "center",
    color: "#FF0000",
    whiteSpace: "nowrap",
  },
  launchIcon: {
    display: "block",
    textAlign: "center",
  },
  text: {
    whiteSpace: "pre-wrap",
    cursor: "pointer",
  },
  imgList: {
    display: "flex",
    flexWrap: "wrap",
  },
  img: {
    marginRight: "5px",
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(3),
    minWidth: 120,
  },
  sticky: {
    position: "-webkit-sticky", /* safari対応 */
    position: "sticky",
    top: 64,
    zIndex: 1,
    backgroundColor: "white",
    paddingLeft: 90,
    paddingRight: 90,
    width: "100%",
  },
}));
function Retweet(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const filter = useFilter();
  const queryParams = useQueryString();

  const fromDate = fromMonthly(filter.state.filteredDateFrom);
  const toDate = toMonthly(filter.state.filteredDateTo);
  const activeGroup = auth.state.activeGroup;

  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(getQueryPageNum(queryParams));
  const [totalCount, setTotalCount] = React.useState(0);
  const [isHideImage, setIsHideImage] = React.useState(false);

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  const handleTableRow = (id) => {
    props.history.push(
      `/retweets/monthly?activeGroup=${activeGroup}&id=${id}&dateTo=${toDate}&dateFrom=${fromDate}`
    );
  };

  const params = {
    range: [fromDate, toDate],
    filter: {
      pn: filter.state.posiNegaTab,
    },
    pagination: {
      page: page,
      limit: "50",
    },
  };

  // 話題情報を取得
  const rquestRetweets = () => {
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }
    request({
      method: "GET",
      url: `data/:account_id/retweets/${
        auth.state.activeGroup
      }/ranking?${convertQueryParam(params)}`,
    }).then((data) => {
      setData(data.data);
      setTotalCount(data.meta.total_count);
      scrollToTop()
    });
  }

  // 初回レンダリングフラグ
  const isFirstRender = React.useRef(false);
  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 話題分析";
    isFirstRender.current = true;
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    // 初回レンダー判定
    if(isFirstRender.current) {
      // 初回レンダーではないように
      isFirstRender.current = false;
    } else {
      rquestRetweets();
    }
  }, [page]);

  const syncQueryPageNum = (...[pn]) => {
    if ((pn && pn === 1) || (totalCount > 0 && (Math.ceil(totalCount / 50)) < getQueryPageNum(queryParams))) {
      modQueryPageNum(queryParams, 1);
      props.history.push(props.location.pathname + "?" + queryParams.toString());
      setPage(1);
    }
    else {
      setPage(getQueryPageNum(queryParams));
    }
  }

  React.useEffect(() => {
    if (auth.state.activeGroup === 0) {
      return;
    }
    if (page === 1) {
      rquestRetweets();
    } else {
      syncQueryPageNum(1);
    }
  }, [auth.state.activeGroup, filter.state]);

  const classes = useStyles();

  const StyledTableCell = withStyles(() => ({
    body: {
      fontSize: 14,
    },
  }))(TableCell);
  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const MyImg = ({ row }) => {
    if (isHideImage) {
      return null;
    }
    let entities = [];
    if (row.tweet.retweeted_status) {
      if (
        row.tweet.retweeted_status.extended_tweet &&
        row.tweet.retweeted_status.extended_tweet.extended_entities &&
          row.tweet.retweeted_status.extended_tweet.extended_entities.media
      ) {
        entities =
          row.tweet.retweeted_status.extended_tweet.extended_entities.media;
      }
      if (
        row.tweet.retweeted_status.extended_entities &&
          row.tweet.retweeted_status.extended_entities.media
      ) {
        entities =
          row.tweet.retweeted_status.extended_entities.media;
      }
    } else {
      if (
        row.tweet.extended_entities && row.tweet.extended_entities.media
      ) {
        entities = row.tweet.extended_entities.media;
      }
    }

    let imgs = [];
    imgs = entities.map((entitie) =>
        <img key={entitie.media_url_https} className={classes.img} src={entitie.media_url_https} alt="ツイート画像" width="300" />
    );

    if (imgs) {
      return (
        <div className={classes.imgList}>
          {imgs}
        </div>
      );
    } else {
      return null;
    }
  };

  const tweetLink = (row) => {
    let tweetLink = "";
    // ツイートがリツイートならば元のツイートのリンクを返す
    if (row.tweet.retweeted_status) {
      tweetLink = "https://twitter.com/" + row.tweet.retweeted_status.user.screen_name 
        + "/status/" + row.tweet.retweeted_status.id_str;
    } else {
      tweetLink = "https://twitter.com/" + row.tweet.user.screen_name 
        + "/status/" + row.tweet.id_str;
    }
    return tweetLink;
  }

  if (page !== getQueryPageNum(queryParams)) {
    syncQueryPageNum();
  }
  return (
    <Layout
      content={
        <Grid container spacing={3}>
          <Toolbar className={classes.sticky}>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-start"
              >
                <DatePickers />
                <div className={classes.divider}></div>
                <PosiTabs />
                <div className={classes.divider}></div>
                <FormControl component="fieldset" className={classes.formControl}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Switch size="small" checked={isHideImage} onChange={(event) => setIsHideImage(event.target.checked)} name="isHideImage" />}
                      label="画像を表示しない"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid container spacing={3} className={classes.formControl} justifyContent="center">
                <MyPagination
                count={Math.ceil(totalCount / 50)}
                currentPage={page}
                handlePagination={(page) => setPage(page)}
                />
              </Grid>
            </Grid>
          </Toolbar>

          {/* Recent Orders */}
          <Grid item xs={12}>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="customized table">
                <TableBody>
                  {data.map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row" className={classes.rank}>
                        {row.rank}
                      </StyledTableCell>
                      <StyledTableCell align="left" className={classes.text} onClick={() => handleTableRow(row.retweet)}>
                        <p>{replaceTweetText(row.tweet)}</p>
                        <MyImg row={row} />
                      </StyledTableCell>
                      <StyledTableCell align="right" className={classes.count}>
                        <span className={classes.count}>{row.count}件</span>
                        <span className={classes.launchIcon}>
                          <a
                            href={tweetLink(row)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LaunchIcon />
                          </a>
                        </span>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      }
    />
  );
}

export default withRouter(Retweet);
